import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface EmptyStateProps {
  children: ReactNode;
  className?: string;
}

export function EmptyState({ children, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex min-h-[40vh] flex-col items-center justify-center rounded-lg border border-dashed bg-muted/30 px-8 py-16 text-center',
        className,
      )}
    >
      <div className="max-w-md text-sm text-muted-foreground">{children}</div>
    </div>
  );
}
